import { render, staticRenderFns } from "./ClientInfoAdminCard.vue?vue&type=template&id=1beabae8"
import script from "./ClientInfoAdminCard.vue?vue&type=script&lang=js"
export * from "./ClientInfoAdminCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports